import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Check, ShieldCheck, Lock, Gift, Users, CreditCard, Clock, Sparkles } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-24 bg-gradient-to-b from-cream to-accent/10" data-id="element-169">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-170">
        {/* Social Proof Banner */}
        <div className="max-w-3xl mx-auto mb-10 bg-white border border-accent/20 rounded-xl p-5 flex items-center justify-center gap-3 text-brown shadow-sm relative overflow-hidden" data-id="element-171">
          <div className="absolute left-0 top-0 h-full w-1 bg-accent" data-id="element-172"></div>
          <Users className="w-6 h-6 text-accent flex-shrink-0" data-id="element-173" />
          <p className="font-bold text-base md:text-lg" data-id="element-174">
            ⭐ Más de 200 mujeres latinas ya generan ingresos con este método.
            <span className="text-accent font-extrabold ml-1" data-id="element-175">
              La próxima eres tú.
            </span>
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border-2 border-accent/20" data-id="element-176">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-177">
            {/* Left: Offer Details */}
            <div className="p-10 md:p-14 bg-brown text-cream flex flex-col justify-center relative overflow-hidden" data-id="element-178">
              {/* Decorative circle */}
              <div className="absolute -top-20 -left-20 w-64 h-64 bg-accent/20 rounded-full blur-3xl" data-id="element-179"></div>

              <h3 className="text-4xl font-serif font-bold mb-3 text-white relative z-10" data-id="element-180">
                Tu Acceso Completo
              </h3>
              <p className="text-accent-light mb-10 font-medium text-lg relative z-10 flex items-center gap-2" data-id="element-181">
                <Sparkles className="w-5 h-5" data-id="element-182" />
                Acceso Inmediato Digital
              </p>

              <div className="space-y-8 mb-10 relative z-10" data-id="element-183">
                <div className="flex items-start justify-between gap-3" data-id="element-184">
                  <div className="flex items-start" data-id="element-185">
                    <div className="bg-accent/20 p-1 rounded-full mr-4 mt-1 flex-shrink-0" data-id="element-186">
                      <Check className="w-4 h-4 text-accent-light" data-id="element-187" />
                    </div>
                    <div data-id="element-188">
                      <span className="text-cream font-bold block text-lg" data-id="element-189">
                        Guía Paso a Paso 'Hogar Dorado'
                      </span>
                      <span className="text-cream/60 text-sm" data-id="element-190">
                        El manual completo para empezar hoy
                      </span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 text-right" data-id="element-191">
                    <span className="line-through text-cream/40 text-sm block" data-id="element-192">
                      $47
                    </span>
                    <span className="bg-accent text-white text-xs font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-193">
                      Incluido
                    </span>
                  </div>
                </div>

                <div className="flex items-start justify-between gap-3" data-id="element-194">
                  <div className="flex items-start" data-id="element-195">
                    <div className="bg-accent/20 p-1 rounded-full mr-4 mt-1 flex-shrink-0" data-id="element-196">
                      <Gift className="w-4 h-4 text-accent-light" data-id="element-197" />
                    </div>
                    <div data-id="element-198">
                      <span className="text-cream font-bold block text-lg" data-id="element-199">
                        BONUS: Calculadora de Precios
                      </span>
                      <span className="text-cream/60 text-sm" data-id="element-200">
                        Nunca más pierdas dinero en tus ventas
                      </span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 text-right" data-id="element-201">
                    <span className="line-through text-cream/40 text-sm block" data-id="element-202">
                      $17
                    </span>
                    <span className="bg-green-400 text-white text-xs font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-203">
                      GRATIS
                    </span>
                  </div>
                </div>

                <div className="flex items-start justify-between gap-3" data-id="element-204">
                  <div className="flex items-start" data-id="element-205">
                    <div className="bg-accent/20 p-1 rounded-full mr-4 mt-1 flex-shrink-0" data-id="element-206">
                      <Gift className="w-4 h-4 text-accent-light" data-id="element-207" />
                    </div>
                    <div data-id="element-208">
                      <span className="text-cream font-bold block text-lg" data-id="element-209">
                        BONUS: Plantillas de WhatsApp
                      </span>
                      <span className="text-cream/60 text-sm" data-id="element-210">
                        Copia y pega para cerrar ventas
                      </span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 text-right" data-id="element-211">
                    <span className="line-through text-cream/40 text-sm block" data-id="element-212">
                      $17
                    </span>
                    <span className="bg-green-400 text-white text-xs font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-213">
                      GRATIS
                    </span>
                  </div>
                </div>

                <div className="flex items-start justify-between gap-3" data-id="element-214">
                  <div className="flex items-start" data-id="element-215">
                    <div className="bg-accent/20 p-1 rounded-full mr-4 mt-1 flex-shrink-0" data-id="element-216">
                      <Gift className="w-4 h-4 text-accent-light" data-id="element-217" />
                    </div>
                    <div data-id="element-218">
                      <span className="text-cream font-bold block text-lg" data-id="element-219">
                        BONUS: Lista de Grupos Rentables
                      </span>
                      <span className="text-cream/60 text-sm" data-id="element-220">
                        Dónde encontrar clientes en Facebook
                      </span>
                    </div>
                  </div>
                  <div className="flex-shrink-0 text-right" data-id="element-221">
                    <span className="line-through text-cream/40 text-sm block" data-id="element-222">
                      $16
                    </span>
                    <span className="bg-green-400 text-white text-xs font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wide" data-id="element-223">
                      GRATIS
                    </span>
                  </div>
                </div>

                {/* Total Value Row */}
                <div className="border-t border-white/20 pt-6 flex items-center justify-between" data-id="element-224">
                  <span className="text-cream/80 font-bold text-base uppercase tracking-wider" data-id="element-225">
                    Valor Total
                  </span>
                  <div className="text-right" data-id="element-226">
                    <span className="line-through text-cream/40 text-sm block" data-id="element-227">
                      $97
                    </span>
                    <span className="text-accent-light font-extrabold text-xl" data-id="element-228">
                      $6.36 USD
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-auto pt-8 border-t border-white/10 relative z-10" data-id="element-229">
                <div className="flex items-center gap-3 text-sm text-cream/70 font-medium" data-id="element-230">
                  <ShieldCheck className="w-6 h-6 text-accent-light" data-id="element-231" />
                  <span data-id="element-232">Garantía de satisfacción de 30 días</span>
                </div>
              </div>
            </div>

            {/* Right: Pricing & CTA */}
            <div className="p-10 md:p-14 flex flex-col justify-center items-center text-center bg-white relative" data-id="element-233">
              {/* Scarcity Badge */}
              <div className="absolute top-6 right-6 bg-accent text-white px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider shadow-lg animate-pulse" data-id="element-234">
                93% Descuento
              </div>

              <span className="text-brown-light font-bold uppercase tracking-widest text-sm mb-4 mt-8" data-id="element-235">
                Precio Regular{' '}
                <span className="line-through decoration-red-400 text-red-400 text-lg ml-1" data-id="element-236">
                  $97
                </span>
              </span>

              <div className="flex items-start justify-center mb-4" data-id="element-237">
                <span className="text-4xl font-bold text-brown mt-2" data-id="element-238">$</span>
                <span className="text-8xl font-serif font-bold text-brown leading-none" data-id="element-239">
                  6.36
                </span>
                <span className="text-2xl font-bold text-brown mt-4" data-id="element-240">USD</span>
              </div>

              <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 px-6 py-2 rounded-full text-base font-bold mb-8 shadow-sm" data-id="element-241">
                🎉 ¡Ahorras $90.64 hoy!
              </div>

              <p className="text-brown-light mb-8 text-lg font-medium" data-id="element-242">
                Menos que un café. Más que un sueldo extra.
              </p>

              {/* Urgency Timer in Card */}
              <div className="flex items-center gap-2 text-red-500 font-bold text-sm mb-4 bg-red-50 px-4 py-1 rounded-full border border-red-100" data-id="element-243">
                <Clock className="w-4 h-4" data-id="element-244" />
                <span data-id="element-245">La oferta expira pronto</span>
              </div>

              <Button variant="accent" fullWidth className="text-xl py-6 shadow-accent/40 shadow-2xl mb-6 hover:scale-[1.02] transition-transform glow-pink" onClick={() => window.open('https://www.betterbysteps.com/cart/44216192499805:1', '_blank')} data-id="element-246">
                ¡QUIERO MI GUÍA POR $6.36!
              </Button>

              <div className="flex flex-col items-center gap-4 mt-2 w-full" data-id="element-247">
                <div className="flex items-center justify-center gap-2 text-xs text-gray-400 font-medium" data-id="element-248">
                  <Lock className="w-3 h-3" data-id="element-249" />
                  <span data-id="element-250">Pago 100% Seguro y Encriptado</span>
                </div>

                {/* Payment Methods */}
                <div className="flex items-center justify-center gap-4 opacity-60 grayscale hover:grayscale-0 transition-all py-2" data-id="element-251">
                  <CreditCard className="w-8 h-8" data-id="element-252" />
                  <span className="text-xs font-bold text-gray-500" data-id="element-253">VISA</span>
                  <span className="text-xs font-bold text-gray-500" data-id="element-254">
                    Mastercard
                  </span>
                  <span className="text-xs font-bold text-gray-500" data-id="element-255">
                    PayPal
                  </span>
                  <span className="text-xs font-bold text-gray-500" data-id="element-256">
                    Apple Pay
                  </span>
                </div>

                <p className="text-[11px] text-gray-400 mt-2 text-center max-w-xs leading-tight" data-id="element-257">
                  Recibes acceso inmediato a tu correo electrónico en menos de 5
                  minutos.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="text-center mt-16" data-id="element-258">
          <p className="text-brown-light/60 text-sm" data-id="element-259">
            ¿Dudas? Escríbenos a soporte@hogardorado.com
          </p>
        </div>
      </div>
    </section>;
}